

export function SaveChangesButton({...params}){
    let handleSaveAllChangesClick = params.handleSaveAllChangesClick


    return (
        <button onClick={(event) => handleSaveAllChangesClick(event)}>SaveChanges</button>
    )
    
}